<template>
  <div @contextmenu.prevent="handler($event)"
       :id="this.id"
       class="sitebuilder-element-container card big-is-receiver"
       element="AccordionComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)"
       :style="style()"
       :key="componentKey"
       v-on:click="focusElement($event)">

    <options-element-bar ref="optionsBar" :elem="this" name='ct-component-AccordionComponent'></options-element-bar>
    <div class="card-header" :id="'heading'+this.id" @click="collapseThis($event)" v-bind:style="{
        borderRadius: radius,
        background: background,
        border : border + ' !important',
        height : height
        }">
      <h5 class="mb-0 clean-text-css h-100">
        <button class="btn btn-link w-100 h-100 icon-place desktop-element accordion-text" data-toggle="collapse"
                :data-target="'#collapse'+this.id" aria-expanded="false"
                :aria-controls="'collapse'+this.id" :style="textStyle()">
          <template v-if="internal_config.icon !== '' && internal_config.iconPosition === 'left'">
            <i :class="$addIconPrefix(internal_config.icon)"></i>
          </template>
          {{ internal_config.text }}
          <template v-if="internal_config.icon !== '' && internal_config.iconPosition === 'right'">
            <i :class="$addIconPrefix(internal_config.icon)"></i>
          </template>
        </button>
        <button class="btn btn-link w-100 h-100 icon-place  mobile-element accordion-text" data-toggle="collapse"
                :data-target="'#collapse'+this.id" aria-expanded="false"
                :aria-controls="'collapse'+this.id" :style="textStyleMobile()">
          <template v-if="internal_config.icon !== '' && internal_config.iconPosition === 'left'">
            <i :class="$addIconPrefix(internal_config.icon)"></i>
          </template>
          {{ internal_config.text }}
          <template v-if="internal_config.icon !== '' && internal_config.iconPosition === 'right'">
            <i :class="$addIconPrefix(internal_config.icon)"></i>
          </template>
        </button>
      </h5>
    </div>

    <div :id="'collapse'+this.id" class="collapse" :aria-labelledby="'heading'+this.id" data-parent="#accordion"
         v-bind:style="{border : borderContainer}">
      <div class="sitebuilder-element-receiver big-is-receiver card-body" v-bind:style="{
         borderRadius: radiusContainer,
        background: backgroundContainer,
        height : heightContainer
        }">
        <component v-for="(element,index) in elements" :is="element.name" :config="element.config" :key="index"
                   :id="element.id" :height_start="index" :preview="preview" :childs="element.childs"
                   @setCallbackChangeDevice="setCallbackChangeDevice"></component>
      </div>
    </div>
    <resources ref="resourcesData"></resources>
  </div>
</template>

<script>

  import Data from './Model';
  import Resources from './Resources.vue';
  import OptionsElementBar from "../../OptionsElementBar";
  import MixinComponents from "../../../../../js/mixins/MixinComponents";

  export default {
    name: 'AccordionComponent',
    props: ['config', 'childs', 'height_start', 'device', 'id', 'preview'],
    mixins: [MixinComponents],
    components: {
      OptionsElementBar,
      Resources
    },
    computed: {
      background() {
        return this.internal_config.backgroundColor;
      },
      heightContainer() {
        return this.internal_config.heightContainer;
      },
      borderContainer() {
        return this.internal_config.borderContainer;
      },
      radiusContainer() {
        return this.internal_config.borderRadiusContainer;
      },
      backgroundContainer() {
        return this.internal_config.backgroundColorContainer;
      },
    },
    data() {
      return Data.data();
    },
    watch: {
      'internal_config': {
        deep: true,
        handler(value) {
          this.$eventHub.setValueElementConfig(this.id, value);
          this.$eventPointer.log(this.id, value);
        }
      },
    },
    created() {
      this.componentKey = '1';
    },
    methods: {
      animation() {
        return false;
      },
      changeOrderPanel(elem, idx) {

        let id = elem.$el.id,
          sibling = idx === 1 ? document.getElementById(id).nextSibling : document.getElementById(id).previousSibling;

        if (sibling === null) {
          return true;
        }

        this.$root.$emit('changeOrderElementsInside', this.id, id, sibling.id, idx);

      },

      collapseThis(e) {

        this.$root.$emit('focusElement', this);
        this.$root.$emit('handlerElement', this);

        e.stopPropagation();
        e.preventDefault();

        $('#collapse' + this.id).collapse('toggle');

        // Tratamento para image3D
        // Aplicando altura/largura para lib
        if (this.preview) {
          this.$nextTick(() => {
            let image3D = this.$el.querySelector('[element="Image3DComponent"]');
            if(image3D){

            let image = image3D.querySelector('.img3D');

              if (!$(image).hasClass('image3D')) {
                let imageClone = $(image).clone();
                $(image3D).empty()
                $(imageClone).appendTo(image3D)
                $(imageClone).addClass('image3D');
                $(imageClone).css('height', 'auto');
                $(imageClone).css('width', $(image3D).width());
                $(image).hasClass('image3D')

                setTimeout(function () {
                  $(imageClone).atvImg();
                }, 1000);

              }
            }
          });
        }
      },

      showResources() {
        return this.$refs.resourcesData.getValuesData();
      },
      style() {
        return `left:  ${this.internal_config.left};
                  top: ${this.internal_config.top};
                  padding-top: ${this.internal_config.paddingTop};
                  padding-left: ${this.internal_config.paddingLeft};
                  padding-right: ${this.internal_config.paddingRight};
                  padding-bottom: ${this.internal_config.paddingBottom};
                  z-index: ${this.internal_config.zIndex};
                  width: ${this.internal_config.width};
                  max-width: ${this.internal_config.maxWidth};
                  margin: 0 auto;`;
      },
      setCallbackChangeDevice(values) {
        this.$emit('setCallbackChangeDevice', values);
      },

      textStyle() {

        if (typeof this.internal_config.textStyle == 'undefined') {
          this.internal_config.textStyle = {
            'family': 'arial, helvetica, sans-serif',
            'size': '15px',
            'sizeMobile': '15px',
            'color': 'White',
            'align': 'center',
            'weight': '700',
            'style': 'initial',
            'stroke': 'none'
          }
        }
        return `font-family:  ${this.internal_config.textStyle.family};
                   font-size: ${this.internal_config.textStyle.size};
                   text-align: ${this.internal_config.textStyle.align};
                   font-weight: ${this.internal_config.textStyle.weight};
                   font-style: ${this.internal_config.textStyle.style};
                   text-decoration: ${this.internal_config.textStyle.stroke};
                   color: ${this.internal_config.textStyle.color}`;
      },
      textStyleMobile() {

        if (typeof this.internal_config.textStyle == 'undefined') {
          this.internal_config.textStyle = {
            'family': 'arial, helvetica, sans-serif',
            'size': '15px',
            'sizeMobile': '15px',
            'color': 'White',
            'align': 'center',
            'weight': '700',
            'style': 'initial',
            'stroke': 'none'
          }
        }
        return `font-family:  ${this.internal_config.textStyle.family};
                   font-size: ${this.internal_config.textStyle.sizeMobile} !important ;
                   text-align: ${this.internal_config.textStyle.align};
                   font-weight: ${this.internal_config.textStyle.weight};
                   font-style: ${this.internal_config.textStyle.style};
                   text-decoration: ${this.internal_config.textStyle.stroke};
                   color: ${this.internal_config.textStyle.color}`;
      },
      buildIcon: function () {
        $(this.$el).find('i').detach();

        if (this.internal_config.icon !== '') {
          if (this.internal_config.iconPosition === 'left') {
            $('<i>').addClass(this.$addIconPrefix(this.internal_config.icon)).prependTo($(this.$el).find('.icon-place').get(0));
            $('<i>').addClass(this.$addIconPrefix(this.internal_config.icon)).prependTo($(this.$el).find('.icon-place').get(1));
          }
          if (this.internal_config.iconPosition === 'right') {
            $('<i>').addClass(this.$addIconPrefix(this.internal_config.icon)).appendTo($(this.$el).find('.icon-place').get(0));
            $('<i>').addClass(this.$addIconPrefix(this.internal_config.icon)).appendTo($(this.$el).find('.icon-place').get(1));
          }
        }
      },
      sendNewChilds() {

        let vm = this;

        setTimeout(() => {
          // console.log(vm.elements);
          vm.$eventPointer.changePointerState(true);
          vm.$eventPointer.logChilds(vm.id, vm.elements);
          setTimeout(() => {
            vm.$eventPointer.changePointerState(true);
          }, 500)
        }, 1000)
      },
    },
    mounted() {

      let device, childs, id, config;
      ({device, childs, id, config} = this.$props);

      if (typeof config.backgroundColor === 'undefined') {
        config.backgroundColor = '#FFFFFF';
      }
      this.internal_config = config;
      this.device = device;

      if (typeof childs === 'undefined') {
        childs = [];
        this.internal_config.childs = [];
      }

      if (typeof id !== 'undefined') {
        this.id = id;
      }

      let objIds = [];
      $('[id]').each(function () {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] == this && parseInt(this.id))
          objIds.push(this.id);
      });

      if (objIds.includes(this.id)) {
        let newId = Date.now() + parseInt(Math.random() * 10000);
        this.id = newId;

        childs.forEach((el, index) => {
          try {
            childs[index].config.parent_id = newId;
          } catch (e) {
          }
        });

        this.$refs.elem.id = newId;
      }

      this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));

      let internal_config = window.mergeRecursive(this.props, this.$props.config);
      this.internal_config = {...internal_config, ...this.internal_config};

      this.$root.$on('setConfigElement', (id, obj) => {
        if (this.id == id) {
          this.config = obj;
          this.internal_config = obj;
        }
      });

      this.$root.$on('setChildsObj', (id) => {
        if (this.id == id) {

          this.$eventPointer.logChilds(this.id, this.elements);

          let childsHub = this.$eventHub.getChilds(this.id);

          this.config.childs = childsHub;
          this.internal_config.childs = childsHub;

          this.elements = {};
          this.$nextTick(() => {
            this.elements = childsHub.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
            this.componentKey += 1;

            this.$nextTick(() => {
              this.sendNewChilds();
              this.$root.$emit('activeSort');
              this.$refs.resourcesData.setValuesData(this);
            });
          });
        }
      });

      this.$root.$on('setChildsUndoRedo', (id, childs) => {
        if (this.id == id) {
          this.$eventHub.setChilds(this.id, childs);

          this.config.childs = childs;
          this.internal_config.childs = childs;

          this.elements = {};
          this.$nextTick(() => {
            this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
            this.componentKey += 1;
          });
        }
      });

      this.$refs.resourcesData.setValuesData(this);
    }
  }

</script>
<style lang="scss" scoped>

.card-body {
  position: relative;
}

.sitebuilder-element-container.card {
  height: auto !important;
  width: 100% !important;
  top: 0 !important;
  left: 0 !important;
  position: relative;
  background-color: transparent !important;
}

[data-device="mobile"] .sitebuilder-element-receiver.card-body,
[data-device="tablet"] .sitebuilder-element-receiver.card-body {
  height: auto !important;
}

.card-header {
  padding: 0 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/AccordionElement/Accordion/Accordion.vue